import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
// import { BsModalRef } from "ngx-bootstrap/modal";
import {
  Combo2Service,
  DCService,
  DesignphotoService,
  StockService,
} from "../../../services/index";

@Component({
  selector: "research-To-Warehouse-TextileDc",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "researchToWarehouseTextileDc.html",
})
export class researchToWarehouseTextileDc implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() _params: any;
  @Output() tabUpdateEvent = new EventEmitter();

  shiftCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();

  row: any;

  invoicedata: any = {
    to_type: "",
    from_type: "",
    ref_no: "",
    totalSample: 0,
    finyear: "",
    totalMtr: "",
  };

  dcNoList: any;
  designColorList: any;
  ColorList: any;
  textileDc = [
    {
      design_no: "",
      color: "",
      width: "",
      dc_no: "",
      qty: 0,
    },
  ];
  dc_id: any;
  printRes: any;

  noofpcs: number;
  box: boolean;
  shirt: boolean;
  dcNoDesignColorList: any;
  stockdata: any = [];
  printPreview = [];
  res1: any;

  typeCheck: boolean;
  isLoadMask: Promise<any>;

  DcList = ["WAREHOUSE", "TEXTILE"];
  typeList = ["Fresh", "Damage"];
  sleeveList = ["F/S", "H/S"];
  fullSizeList = ["f36", "f38", "f40", "f42", "f44", "f46"];
  halfSizeList = ["h36", "h38", "h40", "h42", "h44", "h46"];
  mode = "Add";
  saveEvent: any;
  beltNoList: any;
  designList: any;
  totshirts: number = 0;
  styles: any;
  samp_id: any;
  styleNoList: any;
  rdDcData: any;
  to_type: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.to_type = val["type"];
    this.saveEvent = val["data"].tabevent;
    let rdDcData = Object.assign({}, val["data"]);
    this.rdDcData = rdDcData;

    if (
      (this.mode == "Edit" || this.mode == "View" || this.mode == "Inward") &&
      this.to_type == "WAREHOUSE"
    ) {
      //this.saveEvent = val['data'].tabevent;
      this.loadeditRdDclist();
    } else if ((this.mode == "Edit" || this.mode == "View" || this.mode == "Inward") &&
      this.to_type == "TEXTILE") {
   
      this.loadeditRdDcTextilelist();
    }
  }

  get params(): any[] {
    return this._params;
  }

  sample_no: any;

  page_id: string = Math.random().toString(36).substr(2, 9) + "_";
  isLoading: boolean = false;
  companyList$ = [];
  sampleno: any;
  mfg_date = new Date();
  act_mfg_date = new Date();
  collarList: any;
  partyList: any = [];
  finyearList = [];
  list: any;
  designnoList = [];
  companyList: Observable<any[]>;
  shadeList = [];
  colorList: any = [];
  shirtList: any = [];
  itemgroupList = [];
  sampleList = [];
  sample: boolean;

  groupData: any = [];
  data: any = {};
  sampledata: any = {
    sample_type: "",
  };
  groupList: any = [];
  categoryList: any;
  type: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public toasterService: ToasterService,
    public datePipe: DatePipe,
    private designService: DesignphotoService,
    private dcService: DCService,
    private stockService: StockService,
    private combo2Service: Combo2Service
  ) {
    this.sample = false;
    this.invoicedata.from_type = "R & D";
    this.data = {
      invoiceList: [],
    };
    this.row = {
      design_no: "",
      shade: "",
      type: "",
      sleeve: "",
      size: "",
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      sample_no: "",
    };
    this.data.invoiceList = [
      {
        design_no: "",
        shade: "",
        type: "",
        sleeve: "",
        size: "",
        f36: 0,
        f38: 0,
        f40: 0,
        f42: 0,
        f44: 0,
        f46: 0,
        h36: 0,
        h38: 0,
        h40: 0,
        h42: 0,
        h44: 0,
        h46: 0,
        sample_no: "",
        act_mfg_date: this.datePipe.transform(this.act_mfg_date, "yyyy-MM-dd"),
        mfg_date: this.datePipe.transform(this.mfg_date, "yyyy-MM-dd"),
      },
    ];
  }
  hotkeys(event) {
    if (this.active) {
    }
  }

  trackByIndex(index: number, value: any) {
    return index;
  }

  ngOnInit(): void {
    this.tableScroll();
    this.getDesignNoList();
    this.finyearCombo();
  }

  tableScroll() {
    $(".workorderbody").height(window.innerHeight - 400);
    $(".workorderbody").width(window.innerWidth - 30);
  }
  getAuto(designColorSamples) {
    if(this.mode == 'Edit'){
      this.checkSample(designColorSamples);
        return
    }
    this.data.invoiceList = this.data.invoiceList.filter(el => el.design_no != '');
    let canSave = true;
    this.data.invoiceList.forEach((arr) => {
      if (arr.sample_no == "" || arr.sample_no == undefined) {
        swal("Make Sure that sample.no are entered");
        canSave = false;
        return false;
      }
    });
    if (canSave) {
      this.designService.getAutoResearchDc({}).then((res: any) => {
        canSave = true;
        this.invoicedata.ref_no = res;
        this.checkSample(designColorSamples);
      });
    }
  }
  getDesignNoList() {
    this.designService.getDesignNoList({}).then((res: any) => {
      this.designList = res;
    });
  }

  onDesignChange(design_no, ind) {
    let design = this.colorList[ind].filter((des) =>
      des.design_no === design_no
    );
    this.data.invoiceList[ind].sample_no = design[0].sample_no;
  }

  onSelectdesign($event, ind) {
    let params = {
      des_id: $event.item.des_id,
      design_no: $event.item.design_no,
      design_id: $event.item.design_id,
    };
    this.data.invoiceList[ind].des_id = $event.item.des_id;
    this.designService.getDesignColorList1(params).then((res: any) => {
      this.colorList[ind] = res;
      this.onDesignChange($event.item.design_no, ind);
      $("#code").focus();
    });
  }
  onSelectColor(design_no, shade, ind) {
    let colorFilter = this.colorList[ind].filter(el => el.dispName == shade && el.chk_design_no == design_no);

    if(colorFilter.length > 0){
      this.data.invoiceList[ind].design_id = colorFilter[0].design_id;
    }
    
    $("#stocktype").focus();
  }
  onSelectSize(size, ind) {
    let res = ['f36', 'f38', 'f40', 'f42', 'f44', 'f46', 'h36', 'h38', 'h40', 'h42', 'h44', 'h46'];
    for (let i = 0; i < res.length; i++) {
      if (res[i] === size) {
        delete this.data.invoiceList[ind][res[i]];
        this.data.invoiceList[ind][res[i]] = 1;
      }else{
        this.data.invoiceList[ind][res[i]] = 0;
      }
    }
  }
  calcTot() {
    this.stockdata.fqty =
      this.stockdata.f36 +
      this.stockdata.f38 +
      this.stockdata.f40 +
      this.stockdata.f42 +
      this.stockdata.f44 +
      this.stockdata.f46;
    this.stockdata.hqty =
      this.stockdata.h36 +
      this.stockdata.h38 +
      this.stockdata.h40 +
      this.stockdata.h42 +
      this.stockdata.h44 +
      this.stockdata.h46;
    this.stockdata.totqty = this.stockdata.fqty + this.stockdata.hqty;
  }
  onCheckSampleStock() {
    var designColorSampleCheck = "( ";
    var designColor = [];
    var sample_no = "";
    var isGreat = true;
    this.data.invoiceList.forEach((el) => {
      if (el.design_no != "") {
        designColor.push(el.design_no + el.shade);
        designColorSampleCheck += "( design_no = '" + el.design_no + "' AND  shade = '" + el.shade + "' AND sample_no = '" + el.sample_no + "' ) OR";
        sample_no += el.sample_no + ",";
        let sampleTotQty =
          Number(el.f36) +
          Number(el.f38) +
          Number(el.f40) +
          Number(el.f42) +
          Number(el.f44) +
          Number(el.f46) +
          Number(el.h36) +
          Number(el.h38) +
          Number(el.h40) +
          Number(el.h42) +
          Number(el.h44) +
          Number(el.h46);
        if (sampleTotQty > 1) {
          swal("Each color in sample design can have only one shirt...");
          isGreat = false;
          return;
        }
        this.invoicedata.totalSample += sampleTotQty;
      }
    });
    if (isGreat) {
      var isDuplicate = designColor.some(function (item, idx) {
        return designColor.indexOf(item) != idx;
      });

      if (isDuplicate) {
        swal("Duplicate Design no, Color Exists");
      } else {
        let samples = sample_no.substring(0, sample_no.length - 1);
        let designColorSamples = designColorSampleCheck.substring(0, designColorSampleCheck.length - 2);
        designColorSamples += ")";
        this.getAuto(designColorSamples);
      }
    } else {
      return;
    }
  }
  checkSample(designColorSamples) {

    if(this.mode == 'Edit'){
      this.onSaveStock();
      return
    }
    let params = {
      designColorSamples: designColorSamples,
    };
    let that = this;
    this.designService
      .checkSample(params)
      .then(function (res: any) {
        let sample = '';
        if(res.data.length > 0){
          res.data.forEach((element) => {
            sample += element.sample_no + ","
          });
          sample = sample.substring(0, sample.length - 1)
        }
        
        if (sample == '') {
          that.onSaveStock();
        } else {
          // let barcode = ("0000000" + res.data.barcode).slice(-7);
          swal("SAMPLE.NO ALREADY EXISTS ON " + sample );
          return false;
        }
      })
      .catch(function (error: any) {
        that.isLoading = false;
        let res = JSON.parse(error._body);
        swal("ERROR", res.message, "error");
      });
  }
  onSaveStock() {
    let that = this;
    let params = {};
    params["dataList"] = Object.assign({}, that.data.invoiceList);
    params["mfg_date"] = that.datePipe.transform(
      params["mfg_date"],
      "yyyy-MM-dd"
    );
    params["act_mfg_date"] = that.datePipe.transform(
      params["act_mfg_date"],
      "yyyy-MM-dd"
    );
    params["res_data"] = JSON.stringify(that.invoicedata);
    swal({
      title: "Are you sure to save this Dc?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;
      that.designService
        .addDesignStockFromResearch(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (res.success) {
            swal("R & D Dc Saved Successfully");
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            that.invoicedata.ref_no = "";
            that.invoicedata.from_type = "";
            that.invoicedata.to_type = "";
            that.invoicedata.totalSample = 0;
            that.data = {
              invoiceList: [],
            };

            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            let tabObj = {
              action: "CloseTab",
              params: {},
            };
            that.tabUpdateEvent.emit(tabObj);
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
          //console.log(error);
        });
    });
  }

  onDeleteRow($event, fld, ind) {
    //     onDeleteRow(ind) {
    //  $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length > 1) {
          that.data.invoiceList.splice(ind, 1);
          if ($("#" + fld + "-" + (ind - 1)).length > 0) {
            $("#" + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
            $("#" + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) { }
    );
  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      shade = this.data.invoiceList[ind]["shade"],
      f36 = this.data.invoiceList[ind].f36,
      f38 = this.data.invoiceList[ind].f38,
      f40 = this.data.invoiceList[ind].f40,
      f42 = this.data.invoiceList[ind].f42,
      f44 = this.data.invoiceList[ind].f44,
      f46 = this.data.invoiceList[ind].f46,
      h36 = this.data.invoiceList[ind].h36,
      h38 = this.data.invoiceList[ind].h38,
      h40 = this.data.invoiceList[ind].h40,
      h42 = this.data.invoiceList[ind].h42,
      h44 = this.data.invoiceList[ind].h44,
      h46 = this.data.invoiceList[ind].h46;
    let nxtRow = $("#row-" + ind).next("tr");
    // let data = this.isRowEmpty(ind);
    if (fld == "design_no" && nxtRow.length == 0) {
      let len = this.data.invoiceList.length;
      let design_no = this.data.invoiceList[len - 1].design_no;
      if (design_no != "") {
        for (let i = 0; i < this.data.invoiceList.length; i++) {
          if (ind + 1 == this.data.invoiceList.length) {
            let rowdetail = Object.assign({}, this.row);

            this.data.invoiceList.push(rowdetail);
          }
        }
        nxtInd = this.data.invoiceList.length - 1;
      }
    } else if (
      fld == "f36" ||
      fld == "f38" ||
      fld == "f40" ||
      fld == "f42" ||
      fld == "f44" ||
      fld == "f46"
    ) {
      $("#" + fld + "-" + nxtInd).select();
    } else if (
      fld == "h36" ||
      fld == "h38" ||
      fld == "h40" ||
      fld == "h42" ||
      fld == "h44" ||
      fld == "h46"
    ) {
      $("#" + fld + "-" + nxtInd).select();
    }
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }

  ngAfterViewInit() {
    if (this.invoicedata.to_type == "WAREHOUSE") {
      setTimeout(() => {
        $("#design_no").focus();
      }, 100);
    }
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (
      nextEl == "f36" ||
      "f38" ||
      "f40" ||
      "f42" ||
      "f44" ||
      "f46" ||
      "h36" ||
      "h38" ||
      "h40" ||
      "h42" ||
      "h44" ||
      "h46"
    ) {
      $("#" + nextEl).select();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    //
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }
  loadeditRdDclist() {
    let params = {
      res_id: this.rdDcData.res_id,
      to_type: "WAREHOUSE",
    };
    this.designService.getEditDcList(params).then((res: any) => {
      this.data.invoiceList = res.data;
      this.invoicedata.ref_no = res.data[0].ref_no;
      this.invoicedata.from_type = res.data[0].from_type;
      this.invoicedata.to_type = res.data[0].to_type;
    });
  }
  loadeditRdDcTextilelist() {
    let params = {
      res_id: this.rdDcData.res_id,
      to_type: "TEXTILE",
    };
    this.designService.getEditDcList(params).then((res: any) => {
      this.textileDc = res.data;
      this.invoicedata.ref_no = res.data[0].ref_no;
      this.invoicedata.from_type = res.data[0].from_type;
      this.invoicedata.to_type = res.data[0].to_type;
      this.invoicedata.finyear = res.data[0].finyear;
    });
  }
  //Textile Dc
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.invoicedata.finyear = res.data[0].finyear;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      if(this.mode !='Edit'){
      that.getdcNoDesignColorList(res.data[0].finyear);
      }
    });
  }

  getdcNoDesignColorList(finyear) {
    let params = {
      finyear: finyear,
    };
    this.dcService.getdcNoDesignColorList(params).then((res: any) => {
      // this.dcNoList = res.data;
      this.dcNoDesignColorList = res.data;

      this.filterDcDesignColor();

      // for (let i = 0; i < this.dcNoDesignColorList.length; i++) {
      //   this.barcodeList[i].barcode = this.barcodeList[i].barcode
      //     .toString()
      //     .padStart(6, "0");
      // }
    });
  }
  filterDcDesignColor() {
    this.dcNoList = Array.from(
      new Set(this.dcNoDesignColorList.map((item: any) => String(item.dc_no)))
    );
    this.designColorList = Array.from(
      new Set(
        this.dcNoDesignColorList.map((item: any) => String(item.design_no))
      )
    );
  }
  onEnterDcNo(dc_no, ind) {
    let exists = this.dcNoList.includes(dc_no);
    if (dc_no != "") {
      if (!exists) {
        this.textileDc[ind].dc_no = "";
        swal(
          "PLEASE ENTER VALID DC NO...THIS DC NO IS NOT IN THIS SELECTED FIN YEAR"
        );
      } else {
        let designColorList1 = this.dcNoDesignColorList.filter(
          (el) => el.dc_no == dc_no
        );
        this.designColorList = Array.from(
          new Set(designColorList1.map((item: any) => String(item.design_no)))
        );
      }
    }
  }

  onEnterDesignNo(design_no, ind) {
    let exists = this.designColorList.includes(design_no);
    if (design_no != "") {
      if (!exists) {
        this.textileDc[ind].design_no = "";
        swal("THERE IS NO DC FOR THIS DESIGN NO IN SELECTED FIN YEAR");
      } else {
        let dcNoList1 = this.dcNoDesignColorList.filter(
          (el) => el.design_no == design_no
        );
        this.dcNoList = Array.from(
          new Set(dcNoList1.map((item: any) => String(item.dc_no)))
        );
        this.ColorList = Array.from(
          new Set(dcNoList1.map((item: any) => String(item.color)))
        );
      }
    }
  }

  onEnterColor(design_no, color, ind) {
    let exists = this.dcNoDesignColorList.filter(
      (el) => el.design_no == design_no && el.color == color
    );
    this.textileDc[ind].width = exists[0].width;
  }

  onGoToNextFldTextile($event, fld, ind) {
    let nxtInd = ind,
      dc_no = this.textileDc[ind]["dc_no"],
      design = this.textileDc[ind]["design_no"],
      color = this.textileDc[ind]["color"],
      width = this.textileDc[ind]["width"],
      qty = this.textileDc[ind]["qty"];

    const nxtRow = $("#row-" + ind).next("tr");
    if (fld == "dc_no" && nxtRow.length == 0) {
      if (this.textileDc[ind].qty == 0) {
        swal({
          title:
            "Please Enter the Valid Mtr for design " +
            this.textileDc[ind].design_no,
          timer: 1000,
          showConfirmButton: false,
        });
        return false;
      }

      const len = this.textileDc.length;
      const dc_no = this.textileDc[len - 1]["dc_no"];
      const qty = this.textileDc[len - 1].qty;
      nxtInd = nxtInd + 1;
      $("#" + this.page_id + "design" + "-" + nxtInd).focus();

      if (dc_no != "" && nxtInd == len) {
        this.textileDc.push({
          dc_no: "",
          design_no: "",
          color: "",
          width: "",
          qty: 0,
        });
        this.filterDcDesignColor();

        $("#" + this.page_id + "dc_no" + "-" + nxtInd).focus();
      } else if (dc_no == "" && nxtInd == len) {
        const a = nxtInd - 1;
        $("#" + this.page_id + "dc_no" + "-" + a).focus();
      } else {
        $("#" + this.page_id + "dc_no" + "-" + nxtInd).focus();

        return false;
      }
    }

    //   nxtInd = this.designList.length - 1;
    else if (fld == "item_name") {
      const nxtRowID = nxtRow[0].id;
      nxtInd = nxtRowID.split("-")[1];
    } else {
      setTimeout(() => {
        $("#" + this.page_id + fld + "-" + nxtInd).focus();
      }, 200);
    }
  }

  onDeleteRowTextile($event, fld, ind) {
    $event.preventDefault();
    const that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.textileDc.length > 1) {
          that.textileDc.splice(ind, 1);

          let totdes = 0;
          const designlist = [];
          for (let i = 0; i < that.textileDc.length; i++) {
            const design = that.textileDc[i].design_no;
            if (design != "") {
              if (designlist.indexOf(design) == -1) {
                designlist.push(design);
                totdes++;
              }
            }
          }

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) { }
    );
  }

  onSaveTextileDc(): void {
    const params = {};
    params["tabevent"] = undefined;
    params["textileDc"] = JSON.stringify(this.textileDc);
    params["dataList"] = JSON.stringify(this.invoicedata);
    //  params['workorder'] = this.dcdata.workorder || '';
    params["mode"] = this.mode;
    params["dc_date"] = this.datePipe.transform(
      params["dc_date"],
      "yyyy-MM-dd"
    );
    const that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to save this Dc?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;
      that.designService
        .addTextileStockFromResearch(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }

          if (res.success) {
            that.textileDc = [
              {
                design_no: "",
                color: "",
                width: "",
                dc_no: "",
                qty: 0,
              },
            ];
            that.invoicedata.ref_no = "";
            that.invoicedata.from_type = "";
            that.invoicedata.to_type = "";
            that.invoicedata.totalMtr = 0;
            that.invoicedata.finyear = "";
            that.dcNoDesignColorList = [];
            that.designColorList = [];
            that.ColorList = [];
            that.dcNoList = [];

            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });

            const tabObj = {
              action: "CloseTab",
              params: {},
            };
            that.tabUpdateEvent.emit(tabObj);
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          const res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }
  getTextileAuto() {
    if(this.mode == 'Edit'){
      this.onSaveTextileDc();
        return
    }
    this.designService.getAutoResearchDc({}).then((res: any) => {
      this.invoicedata.ref_no = res;
      this.onSaveTextileDc();
    });
  }

  calctotTextile() {
    let totmtr = 0;
    for (let i = 0; i < this.textileDc.length; i++) {
      const dcdata = this.textileDc[i];
      totmtr += dcdata.qty;
    }

    this.invoicedata.totalMtr = totmtr;
  }

  //Inward Stock
  closeModal(convertType) {
    if (convertType == "WAREHOUSE") {
      $("#printprWarehouse").modal("hide");
    } else if (convertType == "TEXTILE") {
      $("#printpr").modal("hide");
    }
    this.subsEvent();
  }
  inwardResearchStock(convertType) {
    let params = {};
    params["convertType"] = convertType;
    params["res_id"] = this.rdDcData.res_id;

    if (convertType == "WAREHOUSE") {
      params["dataList"] = JSON.stringify(this.data.invoiceList);
    } else if (convertType == "TEXTILE") {
      params["dataList"] = JSON.stringify(this.textileDc);
    }
    const that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to inward this Dc?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;
      that.designService
        .inwardTextileWarehouseStock(params)
        .then(function (res: any) {
          that.isLoading = false;

          if (res.success) {
            that.printRes = res;
            if (convertType == "WAREHOUSE") {
              that.printPreview = res.printData;
              that.res1 = res.printData;
              $("#printprWarehouse").modal("show");
            } else if (convertType == "TEXTILE") {
              that.dc_id = res.printData;
              $("#printpr").modal("show");
            }
            that.textileDc = [
              {
                design_no: "",
                color: "",
                width: "",
                dc_no: "",
                qty: 0,
              },
            ];
            that.data = {
              invoiceList: [],
            };
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          const res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }

  printremainlist() {
    let row;
    let params = {
      dc_id: this.dc_id,
    };

    // this.dcService.remainList(params).then((res: any) => {
    //   this.data.dcdata = res.data;
    //   this.clickPrint(row, res.data);
    //   console.log(res.data);
    // });
    this.dcService.availList(params).then((res: any) => {
      this.data.dcdata1 = res.data;
      console.log(res.data);
      if (res.data.length != 0) {
        this.clickPrintavail(row, res.data);
      }
    });
  }

  clickPrintavail(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);

    that.isLoadMask = that.dcService
      .dcavailPrint(params)
      .then(function (res: any) { });
    that.closeModal("TEXTILE");
  }
  // clickPrint(row, data) {
  //   let that = this;
  //   let params: any = Object.assign({}, row);
  //   params["data"] = JSON.stringify(data);
  //   that.isLoadMask = that.dcService
  //     .dcremainPrint(params)
  //     .then(function (res: any) {});
  //   that.closeModal("TEXTILE");
  // }

  //shirt print

  printdata() {
    this.noofpcs = 1;

    if ($("#box").is(":checked")) {
      this.box = true;
    } else {
      this.box = false;
    }
    if ($("#shirt").is(":checked")) {
      this.shirt = true;
    } else {
      this.shirt = false;
    }
    if (this.box == false && this.shirt == false) {
      swal("PLEASE SELECT ATLEAST ONE");
    } else {
      $("#box").prop("checked", false);
      $("#shirt").prop("checked", false);
      $("#printpr").modal("hide");
      let data = this.res1;

      let params = {
        export: false,
        noofpcs: this.noofpcs,
        designdet: JSON.stringify(data),
        box: this.box,
        shirt: this.shirt,
      };
      this.isLoadMask = this.stockService.print(params);
      this.closeModal("WAREHOUSE");
    }
  }
  subsEvent() {
    if (this.saveEvent) {
      this.saveEvent.emit();
    }

    const tabObj = {
      action: "CloseTab",
      params: {},
    };

    this.tabUpdateEvent.emit(tabObj);
  }

  ngOnDestroy() { }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/researchToWarehouseTextileDc/researchToWarehouseTextileDc.ts